import { useMemo } from "react";
import { Route, Routes } from 'react-router-dom';

import { TonConnectUIProvider } from '@tonconnect/ui-react';

import AuthForm from './AuthForm';
import AdminPanel from './components/AdminPanel';
import Game from './components/Game';
import IslandGame from "./components/IslandGame";
import NotFound from './components/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import WalletConnect from './components/WalletConnect';
import { UserProvider } from './context/UserContext';
import { ScoreProvider } from './context/ScoreContext';
import { ToastProvider } from './context/ToastContext';

// import '@solana/wallet-adapter-react-ui/styles.css'; // Removed Solana styles


const GameRoutes = () => {
    // Manifest URL for TON Connect
    // In production, this should be an absolute URL to the hosted manifest.json
    const manifestUrl = 'https://colourview.io/tonconnect-manifest.json';

    return (
        <TonConnectUIProvider manifestUrl={manifestUrl}>
            <ToastProvider>
                <UserProvider>
                    <ScoreProvider>
                        <Routes>
                            <Route path="/" element={<WalletConnect />} />
                            <Route path="/login" element={<AuthForm />} />
                            <Route
                                path="/game"
                                element={
                                    <ProtectedRoute>
                                        <Game />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <AdminPanel />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path='/island/:islandId' element={<IslandGame />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </ScoreProvider>
                </UserProvider>
            </ToastProvider>
        </TonConnectUIProvider>
    );
};

export default GameRoutes;
